<div id="stickySection" class="sticky-header" *ngIf="cardDetails"
    [ngClass]="{'without-cardArt': !cardDetails?.showStickyCard,'right-align-bg': rightAligned}" role="presentation" aria-hidden="true" tabindex="-1">
    <div class="inner-box" *ngIf="!rightAligned">
        <app-card-art [tabIndex]="'-1'" [hidden]="!isStickyCardShow" [pid]="cardDetails?.pidPT" [defaultSize]="cardImageSize" [priority]="true"
            [linkHref]="acqLink || cardApplyNowBtnLink" [enablePdpLink]="false" [linkTarget]="hrefTarget" (click)="applyNow('cardImageStickyNav')"></app-card-art>
        <h2 class="sticky-card-title"
            [innerHTML]="cardDetails?.stickyCardName || cardDetails?.cardName | adaFriendlyName: 'ignoreHtmlTags'"></h2>
        <div class="contact-support" [innerHTML]="cardDetails?.customerSupportText"></div>
        <ui-card-button [tabIndex]="'-1'" [btnName]="cardDetails?.cardApplyNowBtnText" [btnLink]="acqLink || cardApplyNowBtnLink"
            [cardName]="cardDetails?.cardName" [size]="'1023'"
            [hrefTarget]="hrefTarget"
            [tagText]="cardDetails?.cardApplyNowBtnText.toLowerCase()+' sticky'" (click)="applyNow('applyNowStickyNav')">
        </ui-card-button>
    </div>

    <div class="inner-box right-align" *ngIf="rightAligned">
        <app-card-art [tabIndex]="'-1'" [pid]="cardDetails?.pidPT" [defaultSize]="cardImageSize" [priority]="true"
            [linkHref]="acqLink || cardApplyNowBtnLink" [enablePdpLink]="false" [linkTarget]="hrefTarget" (click)="applyNow('cardImageStickyNav')"></app-card-art>
        <div class="contact-support" *ngIf="headerContent?.callToApply">
            <button role="link" cdsButton="inlineLink" #calltoApplySticky  tabindex="-1" (click)="openCallToApply($event)"
            [innerHTML]="headerContent?.callToApply?.callToApplyText"
            ></button>
        </div>
        <div class="sticky-header-spacer" role="presentation" aria-hidden="true" *ngIf="!headerContent?.callToApply"></div>
        <!-- <div class="spacer" *ngIf="!cardDetails?.customerSupportText"></div> -->
        <ui-card-button [tabIndex]="'-1'" [btnName]="cardDetails?.cardApplyNowBtnText" [btnLink]="acqLink || cardApplyNowBtnLink"
            [cardName]="cardDetails?.cardName" [size]="'1023'"
            [hrefTarget]="hrefTarget"
            [tagText]="cardDetails?.cardApplyNowBtnText.toLowerCase()+' sticky'" (click)="applyNow('applyNowStickyNav')">
        </ui-card-button>
    </div>
</div>
